import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-otpverify',
  templateUrl: './otpverify.component.html',
  styleUrls: ['./otpverify.component.css']
})
export class OtpverifyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
   $('.otpverifyBgImg').css({'width':window.innerWidth+12,'height':window.innerHeight});
  }

}
